import { AfterViewInit, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { bankDataByBIC, isValidBIC } from 'bankdata-germany';
import { IBAN } from 'ibankit';
import { ibanToBic } from 'iban-to-bic';
import { I18nService } from '../../../core/services/i18n.service';
import { PaymentData } from '../../interfaces/payment/payment-data';
import { PaymentInvalidFlags } from '../../interfaces/payment/payment-invalid-flags';

@Component({
  template: '',
})
export abstract class BaseEditPaymentBankAccountComponent implements AfterViewInit {

  @Input() paymentData: PaymentData;
  @Input() paymentInvalidFlags: PaymentInvalidFlags;
  @Output() ibanValidated = new EventEmitter<boolean>()

  public i18n = inject(I18nService);

  /**
   * show invalid IBAN help
   */
  showInvalidIBAN: boolean = false;

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.paymentData.status === 'LIVE') {
        this.checkIBAN();
      } else {
        this.ibanValidated.emit(true);
      }
    }, 10);
  }

  /**
   * validate IBAN and fetch BIC
   * in TEST-Mode only check the IBAN when IBAN-Data was entered
   */
  checkIBAN() {
    this.paymentData.IBAN = this.paymentData.IBAN.toUpperCase();
    if (this.paymentData.status === 'LIVE') {
      if (this.paymentData.IBAN.trim() === '') {
        this.showInvalidIBAN = false;
      } else {
        this.showInvalidIBAN = !IBAN.isValid(this.paymentData.IBAN);
      }
    } else {
      this.showInvalidIBAN = !IBAN.isValid(this.paymentData.IBAN);
    }
    if (!this.showInvalidIBAN) {
      this.paymentData.BIC = ibanToBic(this.paymentData.IBAN);
      if (isValidBIC(this.paymentData.BIC)) {
        this.paymentData.bank = bankDataByBIC(this.paymentData.BIC).bankName;
      }
    }
    this.ibanValidated.emit(!this.showInvalidIBAN);
  }

}

